import { toType } from "src/utils/helpers";
import Avatar from "src/components/base/Avatar/Avatar";
import type { Color } from "src/types";
import { KeyValueContent } from "./KeyValueContent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Typography } from "src/latest/src/components";

const renderValues = (value: any, color: Color, isRemoveTitle: boolean) => {
    return toType(value) === "array" ? (
        value.length > 0 &&
            value?.map((val: any) => (
                <Typography
                    variant="size-16"
                    weight="regular"
                    color={color !== undefined ? color : "color-2"}
                    className={
                        "therapist-client-profile__value-first" + isRemoveTitle
                            ? "mt-0"
                            : ""
                    }
                >
                    {val} <br />
                </Typography>
            ))
    ) : (
        <Typography
            variant="size-16"
            weight="regular"
            color={color !== undefined ? color : "color-2"}
            className={`therapist-client-profile__value-first ${
                isRemoveTitle ? "mt-0" : ""
            }`}
        >
            {value}
        </Typography>
    );
};

type Props = {
    title: string;
    value: any;
    isRemoveTitle: boolean;
    icon: IconProp;
    bgColor: string;
    color: Color;
    removeHtml: boolean;
    classname: string;
    isAvatar: boolean;
    avatarUrl: string;
};

export const Content = ({
    title,
    value,
    isRemoveTitle,
    icon,
    bgColor,
    color,
    removeHtml,
    classname,
    isAvatar = false,
    avatarUrl,
}: Props) => {
    return (
        <div>
            {!isRemoveTitle && (
                <Typography
                    variant="size-14"
                    weight="bold"
                    color="color-28"
                    className={`therapist-client-profile__title ${classname}`}
                >
                    {!removeHtml ? title?.toUpperCase() : title}
                </Typography>
            )}
            {toType(value) === "array" && toType(value[0]) === "object" ? (
                <KeyValueContent value={value} />
            ) : (
                <div
                    className={
                        icon || isAvatar
                            ? "therapist-client-profile__icon-container"
                            : ""
                    }
                >
                    {isAvatar && (
                        <div
                            className={"avatar-container"}
                            style={{
                                border: "3px solid #fff",
                                borderRadius: "50%",
                                boxShadow: "0 3px 6px 0 rgba(0,0,0,0.1);",
                                marginRight: "10px",
                            }}
                        >
                            <Avatar
                                size="25px"
                                photoUrl={avatarUrl}
                                className="profile-avatar"
                                fullName = {value}
                            />
                        </div>
                    )}
                    {icon && (
                        <span
                            className="therapist-client-profile__icon"
                            style={{ background: bgColor }}
                        >
                            <FontAwesomeIcon icon={icon} color="#fff" />
                        </span>
                    )}
                    {isAvatar === true && (
                        <b>{renderValues(value, color, isRemoveTitle)}</b>
                    )}
                    {isAvatar === false && (
                        <b>{renderValues(value, color, isRemoveTitle)}</b>
                    )}
                </div>
            )}
        </div>
    );
};
